<script setup lang="ts">

const props = defineProps<{
	ownerInfo: any;
	cid: string;
}>();

const ownerInfo = computed(() => props.ownerInfo);

const ownerAddContact = computed(() => ownerInfo.value.addContact);

const ownerAddContactList = computed(() => {
	let result = [];
	if(ownerAddContact.value !== null){
		result = ownerAddContact.value.split(',');
	}
	return result;
})

</script>

<template>
	<div class="content">
		<div class="wrapper" v-if="ownerInfo">
			<div class="content-wrapper">
				<span class="first_letter">설치자명</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.ownerName) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">아이디</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.userId) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">연락처</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.mobile) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">사업연도</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.prjRegYear) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">사업구분</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.prjKindName) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">건물용도</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.buildingUsageName) }}</span>
			</div>
			<div class="content-wrapper">
				<span class="first_letter">한국전력 고객번호</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.kepcoId) }}</span>
			</div>
			<div class="content-wrapper">
				<span class="first_letter">요금제</span>
				<span>{{ commonUtils.isAllStrDataEmpty(ownerInfo.usagePlanName) }}</span>
			</div>
			<div class="content-wrapper" v-if="ownerAddContact !== null">
				<span class="first_letter">추가 연락처</span>
				<span 

				>
				<div
				v-for="contact in ownerAddContactList"
				:key="contact"
				>
				{{ contact }}
				</div>
			</span>
			</div>
		</div>
			<div class="spec-no-data" v-else>수용가정보가 존재하지 않습니다.</div>
	</div>

</template>

<style lang="scss" scoped>
@import '@/assets/styles/design-toc/in-equip-card.scss'
</style>